import { SpacingY } from "@src/components/SpacingY"
import styled from "styled-components"

export const HumanRiskDashboardContainer = styled(SpacingY).attrs({
  size: "md",
})`
  min-width: 1068px;
`
